import styled, { createGlobalStyle } from "styled-components";
import Button, {
  buttonThemes
} from "@streeteasy/design-system/deprecated/actions/button";

import CloseButtonBase from "../close-button";
import { TEXT_SECONDARY, WHITE } from "../colors";
import componentSizes from "../constants/componentSizes";
import { LARGE_SCREEN } from "../constants/screenSizes";
import BaseModal from "../modal";
import { Body, Caps, H3 } from "../typography";
import { overlayClassName } from "./constants/overlay";

export const OverlayGlobalStyle = createGlobalStyle`
  .${overlayClassName} {
    &.ReactModal__Overlay {
      opacity: 0;
      transition: opacity 0.5s ease-in-out;
    }

    &.ReactModal__Overlay--after-open{
      opacity: 1;
    }

    &.ReactModal__Overlay--before-close{
      opacity: 0;
    }
  }
`;

export const Modal = styled(BaseModal)`
  box-shadow: -8px 0 24px rgba(0, 0, 0, 0.16);
  max-height: 100vh;
  position: absolute;
  transition: right 0.5s ease-in-out;

  &.ReactModal__Content {
    right: -520px;
  }

  &.ReactModal__Content--after-open {
    right: 0;
  }

  &.ReactModal__Content--before-close {
    right: -520px;
  }

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    width: 100%;
  }
`;

const IconButton = styled(Button).attrs({
  size: componentSizes.LG,
  theme: buttonThemes.SECONDARY
})`
  align-items: center;
  display: flex;
  justify-content: center;
  min-width: auto;
  padding: 0;
  width: 48px;
`;

export const CloseButton = styled(CloseButtonBase)`
  position: absolute;
  right: 24px;
  top: 24px;
  z-index: 1;
`;

export const BackButton = styled(IconButton)`
  flex: 0 0 48px;
  margin-bottom: 24px;
`;

export const SidePanelWrapper = styled.div`
  align-items: flex-start;
  background: ${WHITE};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: 24px;
  position: relative;
  text-align: left;
  width: 520px;

  * {
    box-sizing: border-box;
  }

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    width: 100%;
  }
`;

export const IllustrationWrapper = styled.div`
  margin-bottom: 24px;

  & > * {
    vertical-align: bottom;
  }
`;

export const Headline = styled(H3)`
  margin-bottom: 8px;
  width: calc(100% - 58px);
`;

export const Description = styled(Body)`
  width: calc(100% - 58px);
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  margin-top: 24px;
  width: 100%;
`;

export const Footer = styled.div`
  background: ${WHITE};
  bottom: 0;
  display: flex;
  margin: auto 0 -24px;
  padding: 24px 0;
  position: sticky;
  width: 100%;

  /**
  * Adds padding to bottom of container so that content is not hidden by
  * search bar on mWeb Safari.
  * This strategy for targeting Safari comes from this BrowserStack article:
  * https://www.browserstack.com/guide/create-browser-specific-css
  */
  @media not all and (min-resolution: 0.001dpcm) {
    @supports (-webkit-appearance: none) and (stroke-color: transparent) {
      @media screen and (max-width: ${LARGE_SCREEN}px) {
        padding-bottom: 100px;
      }
    }
  }
`;

export const PrimaryAction = styled.div`
  flex: 1;
`;

export const SecondaryAction = styled.div`
  flex: 1;

  & + ${PrimaryAction} {
    margin-left: 8px;
  }
`;

const BaseButton = styled(Button).attrs({
  size: componentSizes.LG,
  type: "button"
})`
  min-width: auto;
  width: 100%;
`;

export const PrimaryButton = styled(BaseButton).attrs({
  theme: buttonThemes.PRIMARY
})``;

export const SecondaryButton = styled(BaseButton).attrs({
  theme: buttonThemes.SECONDARY
})``;

export const DangerButton = styled(BaseButton).attrs({
  theme: buttonThemes.DANGER_PRIMARY
})``;

export const Legend = styled(Caps).attrs({ as: "legend" })`
  color: ${TEXT_SECONDARY};
`;
